import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api from '../../utils/api';
import { InfoButton } from '../../components/InfoModal';

export default function OurPartnerTab() {
  const navigate = useNavigate();

  const { data: partners = [], isLoading } = useQuery({
    queryKey: ['partner-companies', 'all'],
    queryFn: async () =>
      (await api.get('/partner-companies', { params: { includeInactive: 1 } })).data?.data || [],
  });

  return (
    <div>
      <div className="flex flex-wrap items-baseline gap-2 mb-4">
        <p className="text-sm text-gray-600">
          Global partner companies used across buildings (IQP partners / Form 12A). Use{' '}
          <strong>Register partner</strong> in the header to add one.
        </p>
        <InfoButton title="Our Partner">
          <p>
            Companies registered as partner companies for SS inspection. Click a row to edit details or set
            Active/Inactive. Inactive partners cannot be assigned to new work, and linked buildings will not
            auto-renew mandate schedules after the current period.
          </p>
        </InfoButton>
      </div>

      <div className="bg-card rounded-lg border border-gray-200 overflow-hidden">
        {isLoading ? (
          <p className="p-8 text-center text-gray-500">Loading…</p>
        ) : partners.length === 0 ? (
          <p className="p-8 text-center text-gray-500">
            No partners yet. Use <strong>Register partner</strong> in the header, or from a building ??Service
            mandates.
          </p>
        ) : (
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left font-medium text-gray-500">Company</th>
                <th className="px-4 py-3 text-left font-medium text-gray-500">Status</th>
                <th className="px-4 py-3 text-left font-medium text-gray-500">IQP</th>
                <th className="px-4 py-3 text-left font-medium text-gray-500">SS</th>
                <th className="px-4 py-3 text-left font-medium text-gray-500">Contact</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {partners.map((p) => (
                <tr
                  key={p.id}
                  className={`hover:bg-gray-50 cursor-pointer ${p.is_active ? '' : 'bg-gray-50/80'}`}
                  onClick={() => navigate(`/network/partners/${p.id}`)}
                >
                  <td className="px-4 py-3 font-medium text-gray-900">{p.name}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                        p.is_active ? 'bg-emerald-100 text-emerald-800' : 'bg-gray-200 text-gray-700'
                      }`}
                    >
                      {p.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-gray-600">{p.iqp_name || p.contact_name || '—'}</td>
                  <td className="px-4 py-3 text-gray-600">
                    {(Array.isArray(p.ss_codes) ? p.ss_codes : []).join(', ') || '—'}
                  </td>
                  <td className="px-4 py-3 text-gray-600">
                    {[p.email, p.phone].filter(Boolean).join(' · ') || '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
